import * as _d3 from "@bfx/d3";
import { BfxStrategyLayoutPlugin } from "./strategy-layout/BfxStrategyLayoutPlugin";

// Refactor
export const d3 = (function () {
  _d3.layout.strategy = function (pricingService) {
    return new BfxStrategyLayoutPlugin(pricingService);
  };

  return _d3;
})();
